/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MoneyCurrencyRubleCircleIcon24Solid = forwardRef('MoneyCurrencyRubleCircleIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M10.5 8v4.25h2.375a2.125 2.125 0 0 0 0-4.25H10.5Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10Zm-11.5 1.75h2.375a3.625 3.625 0 0 0 0-7.25h-2.706C9.523 6.5 9 7.023 9 7.669v4.581h-.75a.75.75 0 0 0 0 1.5H9V15h-.75a.75.75 0 0 0 0 1.5H9v1a.75.75 0 0 0 1.5 0v-1h3a.75.75 0 0 0 0-1.5h-3v-1.25Z" })));
});
